var _require = require('@antv/util'),
    mix = _require.mix;

module.exports = {
  assign: mix
};


//////////////////
// WEBPACK FOOTER
// ./src/util.js
// module id = 7
// module chunks = 0